import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Text, Anchor } from '@mantine/core';
import { LinkedinLogo } from '@phosphor-icons/react';
import Logo from './Logo';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-gray-100 border-t border-gray-200 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <Link to="/" className="flex items-center mb-4">
              <Logo className="h-8" />
            </Link>
            <Text size="sm" c="gray.7" className="leading-relaxed">
              {t('footer.tagline')}
            </Text>
            <a
              href="https://www.linkedin.com/company/droid-pl/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t('footer.linkedinAria')}
              className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-gray-700 hover:text-[#0A66C2] transition"
            >
              <LinkedinLogo size={18} weight="fill" /> LinkedIn
            </a>
          </div>
          <div>
            <Text fw={600} size="sm" c="dark" mb="md">{t('footer.navHeading')}</Text>
            <div className="space-y-2">
              <div>
                <Anchor component={Link} to="/funkcje" size="sm" c="gray.7" underline="hover">
                  {t('footer.features')}
                </Anchor>
              </div>
              <div>
                <Anchor component={Link} to="/cennik" size="sm" c="gray.7" underline="hover">
                  {t('footer.pricing')}
                </Anchor>
              </div>
              <div>
                <Anchor component={Link} to="/kontakt" size="sm" c="gray.7" underline="hover">
                  {t('footer.contact')}
                </Anchor>
              </div>
            </div>
          </div>
          <div>
            <Text fw={600} size="sm" c="dark" mb="md">{t('footer.legalHeading')}</Text>
            <div className="space-y-2">
              <div>
                <Anchor component={Link} to="/regulamin" size="sm" c="gray.7" underline="hover">
                  {t('footer.terms')}
                </Anchor>
              </div>
              <div>
                <Anchor component={Link} to="/polityka-prywatnosci" size="sm" c="gray.7" underline="hover">
                  {t('footer.privacy')}
                </Anchor>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <Text size="sm" c="gray.8">
            {t('footer.copyright')}
          </Text>
          <Text size="sm" c="gray.8">
            {t('footer.madeBy')} <Anchor href="https://upcode.pl" target="_blank" size="sm" c="gray.8" underline="hover" fw={500}>Upcode</Anchor>
          </Text>
        </div>
      </div>
    </footer>
  );
}
